/* eslint-disable no-console */
import { GridApi, IDatasource, IGetRowsParams } from "ag-grid-community";

import { RestClient } from "@elite/restclient";

import IDataSourceResponse from "./IDataSourceResponse";

export default class AjaxDataSource<TModel> implements IDatasource {
    restClient: RestClient;
    baseUrl: string;
    additionalData: (() => Record<string, unknown>) | null = null;
    gridApi: GridApi | null;

    constructor(
        restClient: RestClient,
        baseUrl: string,
        additionalData: (() => Record<string, unknown>) | undefined = undefined,
        gridApi?: GridApi | null
    ) {
        this.restClient = restClient;
        this.baseUrl = baseUrl;
        this.gridApi = gridApi || null;

        if (additionalData) {
            this.additionalData = additionalData;
        }
    }

    getRows(params: IGetRowsParams) {
        if (this.gridApi) {
            this.gridApi.showLoadingOverlay();
        }

        const dataSourceRequest = {
            startRow: params.startRow,
            endRow: params.endRow,
            sorts: params.sortModel,
            filters: params.filterModel,
            additionalData: this.additionalData ? this.additionalData() : null
        };

        this.restClient
            .postJson<IDataSourceResponse<TModel>>(
                this.baseUrl,
                dataSourceRequest
            )
            .then(response => {
                if (response.status != 200 || !response.data) {
                    params.failCallback();

                    return;
                }

                if (this.gridApi) {
                    this.gridApi.hideOverlay();
                }

                params.successCallback(
                    response.data.data,
                    response.data.lastRow || response.data.lastRow === 0
                        ? response.data.lastRow
                        : undefined
                );

                // After data is loaded, size columns to fit.
                if (this.gridApi) {
                    this.gridApi.sizeColumnsToFit();
                }
            });
    }
}
